import doesActiveExperiencesInclude from './doesActiveExperiencesInclude';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Checks to see if the user has Teams Premium Personalized license
 * @returns true if the user has Teams Premium Personalized license
 */
export default function isTeamsProCustomizationUser(mailboxInfo?: MailboxInfo): boolean {
    return doesActiveExperiencesInclude('TeamsProCustomization', mailboxInfo);
}
